
import React,{useRef,useState,useEffect,memo,useCallback} from 'react'
import {useParams} from 'react-router-dom'
import Page from './Page'
import {fetchCMSJSON} from 'system/AssetManager'
import axios from 'axios'
import Globals from 'system/Globals'
import gsap from 'gsap'


const PageRender = function(props){

    let { id,pageid } = useParams();
    
    let [pageModel,setPageModel] = useState(null)

    const [loading , setLoading ]= useState(true)
    // Distinct from `loading`. `loading` only tracks the page JSON fetch, so the existing
    // `loaded` class goes on as soon as the model arrives -- long before any image, video
    // or module has painted. That gap is what sleep(7) has been papering over in
    // GenerateSectionPDF. `render-ready` is the real signal and is purely ADDITIVE: the
    // `loaded` class is untouched, so nothing currently relying on it changes behaviour.
    const [renderReady, setRenderReady] = useState(false)
    // Guards waitForMedia against being armed twice; see onPageLoad.
    const refSettling = useRef(false)
    const [tempUser, setTempUser] = useState(true);

    const [forceFormat, setForceFormat] = useState(null);

    useEffect(()=>{

        if (props && props.location.search) {
            let narrativeToken;

            let params = new URLSearchParams(props.location.search)
            narrativeToken = params.get('u');

            let fw = params.get('w');
            let fh = params.get('h');
            if (fw && fh) {
                setForceFormat({ canvas_width: fw + 'px', canvas_height: fh + 'px', aspect_ratio: (parseFloat(fw)/parseFloat(fh)).toFixed(3) });
            }
            
            console.log(narrativeToken)
            
            if (narrativeToken) {
             
                axios({
                    method: 'post',
                    baseURL: Globals.instance().adminOriginAPI,
                    url: 'api/core/verify-narrative-token/',
                    data: {
                        "link_token": narrativeToken,
                        "narrative_id": id
                    }
                    })
                    .then(response => {  

                        let userObj = {}
                        userObj.narratives = [parseInt(id)]
                        userObj.market= null
                        userObj.category= "anon"
                        userObj.device_sn = null
                        userObj.link_token = narrativeToken
                        userObj.token = narrativeToken
                        console.log('userObj', userObj)
                        // props.setUser(userObj)
                        setTempUser(userObj)

                    }).catch(function (error) {
                        console.error(error.response)    
                        
                    })
    
            } 
        } 
       
        console.log('Globals', Globals)

    },[props])

    useEffect(() => {
        if (tempUser) {
            const loadPage = async (url)=>{
                try{
                    let pm = await fetchCMSJSON(url,null,null,tempUser.token)
                    setPageModel(pm)
                    setLoading(false)
                }catch( e ){
                
                    console.error(e)
             
                }
            }
            console.log('narrative', id)
           loadPage('narrative/'+id+'/'+pageid+'/?format=json')
        }
    }, [tempUser])

    function setScrollTable(){

    }
    // Page calls this once every component on the page has reported itself loaded
    // (Page.js onLoadComplete). It used to be an empty function, so the one signal that
    // actually means "this page has finished" was thrown away -- which is why the PDF
    // renderer screenshots on a fixed sleep(7) instead of waiting for anything real.
    function onPageLoad(){
        /* Page reports "every component has reported itself loaded". Necessary, but not
           sufficient to screenshot: load events fire on the main thread, while the pixels
           only exist once the compositor has produced a frame containing them. Selenium
           takes the screenshot the instant this class appears -- staging logs showed every
           page signalling ready in 0.0-0.3s -- so without a settle the PDF captured pages
           mid-paint (#1853, returned). Live never showed it because live still sleeps 7s.

           fonts.ready first, since text reflows when a webfont swaps in and a reflow after
           the screenshot is a page laid out wrong. Then two animation frames: the first
           schedules the paint, the second only runs once that paint has been committed. */
        /* Snap every in-flight animation to its end state BEFORE declaring ready.

           Components reveal themselves with a 0.2s fade from opacity 0 (PNG, SVG, POP,
           SVGButton; PNG.arBox adds a 1s delay on top). "Loaded" fires when the fade
           STARTS, so the screenshot was catching layers mid-reveal -- measured in the
           render container, 5-7 elements per page sat at opacity 0.00 at the instant
           render-ready appeared and only reached 1.00 later. How many, and how far along,
           varied per page, which is why coloration looked inconsistent across a deck
           rather than uniformly wrong (#1861).

           Done here rather than by making each renderer skip its fade: one place, and it
           covers animations added later without anyone remembering this constraint. Safe
           because PageRender is bound solely to /render/narrative and always passes
           renderOnly -- presentation never runs this. Finishing a tween early is also
           already the convention on this path (see setFinalAnimIntersectState). */
        const finishAnimations = () => {
            try {
                gsap.globalTimeline.getChildren(true, true, true).forEach((t) => {
                    // Infinite tweens never reach totalProgress 1; progress(1) lands them
                    // on the end of the current iteration, which is a fine still frame.
                    if (t.progress() < 1) t.progress(1)
                })

                /* Completing tweens is not sufficient, because the reveal sometimes has NO
                   tween to complete. `.arBoxInner` is opacity 0 in CSS (index.scss) and is
                   revealed only by the fade in each renderer's onLoad. When the image is
                   already cached, that load event fires before React has attached the ref,
                   so `gsap.to(null, ...)` quietly creates nothing -- the wrapper then sits
                   at 0 until an unrelated effect happens to fade it, which lands well after
                   the screenshot. Measured: wrappers at opacity 0.00 with no inline style
                   at all, reaching 1.00 only afterwards.

                   Every one of those fades targets {opacity: 1}, so 1 is this wrapper's
                   terminal state by construction -- forcing it is exact, not a guess.
                   Layers the author actually hid (interaction targets) carry their own
                   inline opacity on .arBox and the <img>, which is left untouched. */
                document.querySelectorAll('.pagerender .arBoxInner').forEach((el) => {
                    if (parseFloat(window.getComputedStyle(el).opacity) < 1) {
                        el.style.opacity = '1'
                    }
                })
            } catch (e) {
                console.warn('render: could not finish animations', e && e.message)
            }
        }
        const settle = () => {
            finishAnimations()
            requestAnimationFrame(() => requestAnimationFrame(() => setRenderReady(true)))
        }
        const withFonts = () => {
            if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
                document.fonts.ready.then(settle).catch(settle)
            } else {
                settle()
            }
        }
        // Only the FIRST call arms the wait. onPageLoad fires more than once per page (see
        // waitForMedia's note), and re-arming would keep pushing the deadline out.
        if (refSettling.current) return
        refSettling.current = true
        waitForMedia().then(withFonts)
    }

    /* Do not trust "the page reported loaded" -- look at the media.

       Page.js has TWO routes to props.onLoad. The one this file was written against counts
       components as each reports itself loaded. The other (Page.js, the effect on
       props.model.components) fires as soon as components.length === components_count,
       which is true for essentially every page the moment the model arrives -- before a
       single image has been REQUESTED, never mind decoded. That early route wins the race,
       which is why the staging render log reads "ready in 0.0s" for every page of every
       deck: the gate has never actually been waiting for content. sleep(7) was doing the
       work, and swapping it for this class replaced 7s with ~0s.

       Measured on section 7467 (#1862): at the instant render-ready appeared, 0 of 11
       images had issued a network request and the screenshot was 9 KB. Fifteen seconds
       later the same page was 535 KB. Pages usually got away with it because the images
       were small or already in Chromium's HTTP cache and landed inside the fonts.ready +
       2-frame window; a page carrying a 12.7 MB PNG never did. Longer decks lose more
       often, hence "10+ page spaces" -- more pages, more rolls of the dice, and a browser
       under more pressure by the end of a run.

       So this waits on the DOM rather than on any callback: every <img> complete, every
       <video> past HAVE_CURRENT_DATA, and the element count stable across two polls so a
       layer that mounts late is not missed. Fixing it here rather than in Page.js on
       purpose -- that early onLoad also wires up scroll and intersection handlers that
       presentation depends on, and this file is the only consumer that means "safe to
       photograph" by it. */
    function waitForMedia(){
        const DEADLINE_MS = 30000
        const POLL_MS = 100
        const t0 = Date.now()
        let lastCount = -1
        return new Promise((resolve) => {
            const check = () => {
                let pending = 0
                let count = 0
                try {
                    const media = document.querySelectorAll('.pagerender img, .pagerender video')
                    count = media.length
                    media.forEach((el) => {
                        if (el.tagName === 'VIDEO') {
                            // HAVE_CURRENT_DATA: there is a frame to photograph. A poster
                            // stands in for video on this path, so this is the fallback for
                            // layers whose poster could not be built.
                            if (el.readyState < 2) pending += 1
                        } else if (!el.complete) {
                            // `complete` also goes true on error, so a 404 cannot hang this.
                            pending += 1
                        }
                    })
                } catch (e) {
                    resolve()
                    return
                }
                const stable = count === lastCount
                lastCount = count
                if (pending === 0 && stable) {
                    // Downloaded is not painted. decode() resolves only once the bitmap is
                    // ready to draw, which is the same distinction that made large
                    // backgrounds screenshot blank in #1853.
                    const imgs = Array.prototype.slice.call(
                        document.querySelectorAll('.pagerender img'))
                    const decodes = imgs.map((im) => (
                        im.decode ? im.decode().catch(() => {}) : Promise.resolve()
                    ))
                    Promise.all(decodes).then(resolve).catch(resolve)
                    return
                }
                if (Date.now() - t0 > DEADLINE_MS) {
                    console.warn('render: media did not settle in ' + DEADLINE_MS + 'ms, ' +
                                 pending + ' of ' + count + ' still pending')
                    resolve()
                    return
                }
                setTimeout(check, POLL_MS)
            }
            check()
        })
    }
    function Interaction(){}
    function onIntersect(){}

    return (<div className={`fullscreen pagerender ${loading?'loading':'loaded'}${renderReady?' render-ready':''}`}>

          { pageModel && (
          <Page key={`${id}-${pageid}` }
            id={`${id}-${pageid}` }
            model={pageModel}
            onLoad={onPageLoad}
            interaction={Interaction}
            pageIndex={0}
            theme={{}}
            onIntersect={onIntersect}
            setScrollCallback={setScrollTable}
            renderOnly={true}
            nid={id}
            index={0}
            flatMenuItems={[]}
            PageModels={[]}
            activePage={pageid}

            ></Page>)
        }


        </div>)
    
}

export default PageRender;
